<div class="d-flex flex-wrap">
  <div class="e-icons-wrap__icon" *ngFor="let tag of tags">
    <i [ngClass]="tag.icon"></i>
    <span>{{tag.name}}</span>
  </div>
</div>
